module.exports = __WEBPACK_EXTERNAL_MODULE_28__;


//////////////////
// WEBPACK FOOTER
// external "ReactRouter"
// module id = 28
// module chunks = 1 2